import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';

import { ThemeToggleComponent } from './theme-toggle.component';

@NgModule({
  declarations: [ThemeToggleComponent],
  exports: [ThemeToggleComponent],
  imports: [CommonModule, NzIconModule, NzButtonModule],
})
export class ThemeToggleModule { }
